import * as ChatOrigins from './constants';

export const tradeInMappings = (url: string) => {
  if (/\/(trade-in)/.test(url)) {
    return [
      [/\/(trade-in\/get-value)(\?|\/|#|$)/, ChatOrigins.TRADE_ORIGIN_GET_VALUE],
      [/\/(trade-in\/valued)(\?|\/|#|$)/, ChatOrigins.TRADE_ORIGIN_VALUED],
      [/\/(trade-in\/decline-reason)(\?|\/|#|$)/, ChatOrigins.TRADE_ORIGIN_DECLINE_REASON],
      [/\/(trade-in\/declined)(\?|\/|#|$)/, ChatOrigins.TRADE_ORIGIN_DECLINED],
    ];
  }
  return [];
};
